"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArchiveImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing Archive operations. */
var ArchiveImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class Archive class.
   * @param client Reference to the service client
   */
  function ArchiveImpl(client) {
    (0, _classCallCheck2["default"])(this, ArchiveImpl);
    this.client = client;
  }
  /**
   * Returns path of archive document (returned value is used to create link to archive document by
   * client side code).
   * Returns null if archive document does not exist for given portalId, hiveId and fullName. (Auth:
   * RhinestoneAuthorize[hiveId, fullName, portalId])
   * @param portalId (Access Controlled)
   * @param hiveId (Access Controlled)
   * @param fullName (Access Controlled)
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(ArchiveImpl, [{
    key: "getArchivedDocumentPath",
    value: function getArchivedDocumentPath(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getArchivedDocumentPathOperationSpec);
    }
  }]);
  return ArchiveImpl;
}(); // Operation Specifications


exports.ArchiveImpl = ArchiveImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getArchivedDocumentPathOperationSpec = {
  path: "/api/Portals({portalId})/Archive/Document/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "String"
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  headerParameters: [Parameters.accept1],
  serializer: serializer
};